export default __webpack_public_path__ + "static/media/1.023b239c.png";